import create from 'zustand';

const basketDraftStoreCreator = () =>
  create<{
    basketDraftList: any[];
    setBasketDraftList: (items: any[]) => void;
  }>((set) => ({
    basketDraftList: [] as any[],
    setBasketDraftList: (items: any[]) => set({ basketDraftList: items }),
  }));

export default basketDraftStoreCreator;
